import * as fromDatatype from '../datatype-library/index';

export interface bl_mlm_program_hdr_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    commission_scheme_guid: fromDatatype.GuidDataFieldInterface;
    terms_and_conditions: fromDatatype.GuidDataFieldInterface;
    website_guid: fromDatatype.GuidDataFieldInterface;
    url_forward: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_mlm_program_hdr_RowClass implements bl_mlm_program_hdr_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    commission_scheme_guid: fromDatatype.GuidDataFieldInterface;
    terms_and_conditions: fromDatatype.GuidDataFieldInterface;
    website_guid: fromDatatype.GuidDataFieldInterface;
    url_forward: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}